export const selectEmployeeLicenceStatus = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-employee-licence-status.html'),
    controller: 'SelectEmployeeLicenceStatusController'
};
